import Vue from 'vue';
import WorkExpansionPanels from '@/components/global_components/expansion-panels/WorkExpansionPanels';
import WorkExpansionPanelHeader from '@/components/global_components/expansion-panels/WorkExpansionPanelHeader';
import WorkExpansionPanelContent from '@/components/global_components/expansion-panels/WorkExpansionPanelContent';

Vue.component('WExpansionPanels', WorkExpansionPanels);
Vue.component('WExpansionPanelHeader', WorkExpansionPanelHeader);
Vue.component('WExpansionPanelContent', WorkExpansionPanelContent);
